import { useEffect, useState } from "react";
import Backdrop from "../../asserts/CRMbg.png";
import "./Dashboard.css";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import PowerBi from "./PowerBi";
import { useDispatch, useSelector } from "react-redux";
import {
  GetNotificationData,
  UnreadNotification,
} from "../../Api/Notification/Notification";
import PowerBIReport from "./PowerBIReport";
import NewPowerbi from "./NewPowerbi";
// import NewPowerbi from "./NewPowerBi";
import {
  GetCancellationDetails,
  GetCancellationDetailsById,
  GetCancellationDetailsByDate,
  handleCancellationDetailsSearch,
} from "../../Api/Dashboard/Dashboard";
import {
  Table,
  Spin,
  Tooltip,
  Popover,
  ConfigProvider,
  DatePicker,
  Select,
} from "antd";
import ReactPaginate from "react-js-pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faAngleDoubleLeft,
  faAngleDoubleRight,
} from "@fortawesome/free-solid-svg-icons";
import { IoIosArrowDropupCircle } from "react-icons/io";
import { IoIosArrowDropdownCircle } from "react-icons/io";

import bus from "../../asserts/umbuslogo.png";

import moment from "moment";
import { MdLocationOn, MdDateRange, MdOutlineAccessTime } from "react-icons/md";
import {
  TiArrowUnsorted,
  TiArrowSortedUp,
  TiArrowSortedDown,
} from "react-icons/ti";
import ModalPopup from "../Common/Modal/Modal";
import { Field, Form, Formik } from "formik";
import {
  GetRefundRequestDetails,
  handleGetOtp,
  handleGetUserNumber,
  handleOTPVerify,
  handleRefundRequestNormal,
  handleGetUser,
} from "../../Api/Payments/Payments";
import { MdVerified, MdError } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { RiRefund2Line } from "react-icons/ri";
import { capitalizeFirstLetter } from "../Common/Captilization";
const { Option } = Select;

export default function CancelTable({ activePage, setActivePage, deviceid,
  sortedData,setSortedData,setSortOrderDate,setSortOrderFare,sortOrderDate,sortOrderFare
 }) {
  const [spinning, setSpinning] = useState(false);
  const [updatedata, SetUpdateData] = useState();
  const [expandedRowKey, setExpandedRowKey] = useState(null);
  const [isRowExpanded, setIsRowExpanded] = useState(false);
  const [operatorData, setOperatorData] = useState();
  const [sortedInfo, setSortedInfo] = useState({});
  const [refund, setRefund] = useState();
  const [mobile, setMobile] = useState();
  const [email, setEmail] = useState();
  const [payId, setPayId] = useState();
  const [ticketNo, setTicketNo] = useState();
  const [currentpage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isTimerRunning, setTimerRunning] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isVerify, setIsVerify] = useState();
  const [verifyStatus, setVerifyStatus] = useState(false);
  const [otp, setOtp] = useState();
  const [selectedUser, setSelectedUser] = useState();
  const [isDisabled, setIsDisabled] = useState(false);
  const [isTimer, setTimer] = useState(false);
  const [submitmodalIsOpen, setSubmitModalIsOpen] = useState(false);
  const [userMessage, setMessage] = useState();
  const [valuesForm, setValues] = useState();
  const [verifyValues, setVerifyValues] = useState();
    const [isClicked, setIsClicked] = useState(false);
    const [otpSendState,setOtpSendState]=useState(false)

  const date1 = new Date("08 June 2025");
  const [date2, setDate2] = useState();
  const date3 = new Date(date2);

  const developperAccess = sessionStorage.getItem("accessId");
  console.log(developperAccess, "ACCESSID");

  const getCancellationDetails =
    useSelector((state) => state.crm.cancellation_details) || [];
  console.log(getCancellationDetails, "cancellation details dashboard");

  const userDetail = useSelector((state) => state.crm.user_detail) || [];
  console.log(userDetail, "user details dashboard");

  const userNumber = useSelector((state) => state.crm.user_number);
  console.log(userNumber, "userNumber dashboard");

  const verifyOtp = sessionStorage.getItem("refundOtp");
  useEffect(() => {
    handleGetUser(dispatch);
  }, []);

  const closeSubmitModal = () => {
    dispatch({ type: "RESETNUMBER" });
    setSubmitModalIsOpen(false);
    setIsModalOpen(false);
    setIsDisabled(false);
    setTimerRunning(false);
    setVerifyStatus(false);
    setTimer(false);
    setTimeLeft();
    setIsVerify();
    setSelectedUser();
    setMessage();
    setOtp();
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setIsVerify();
    setIsDisabled(false);
    setTimer(false);
    setTimerRunning(false);
    setTimeLeft();
    setSelectedUser();
    setVerifyStatus(false);
    setOtp("");
    setMessage();
    dispatch({ type: "RESETNUMBER" });
  };

  const handleSubmitClick = () => {
    setSpinning(true);
    if (deviceid === 0) {
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 1) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 2) {
      console.log("BookingTable deviceId:", deviceid);
      GetRefundRequestDetails(dispatch, setSpinning, deviceid);
    }

    setIsModalOpen(false);
    setSubmitModalIsOpen(false);
    dispatch({ type: "RESETNUMBER" });
  };

  const formatTimer = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, "0")} : ${String(secs).padStart(
      2,
      "0"
    )}`;
  };

  // Timer logic
  // useEffect(() => {
  //   let timer;
  //   if (timeLeft > 0) {
  //     timer = setInterval(() => {
  //       setTimeLeft((prev) => prev - 1);
  //       setTimerRunning(true);
  //     }, 1000);
  //   } else if (timeLeft === 0 && isDisabled) {
  //     setIsDisabled(false);
  //     // setTimer(false);
  //     // setTimeLeft(false);
  //   }
  //   return () => clearInterval(timer);
  // }, [timeLeft, isDisabled]);

  useEffect(() => {
  if (!isDisabled || timeLeft <= 0) return;
 
  const timer = setInterval(() => {
    setTimeLeft((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        setIsDisabled(false);
        return 0;
      }
      return prev - 1;
    });
  }, 1000);
 
  return () => clearInterval(timer);
}, [isDisabled]);

  const handleVerify = async (values) => {
    setTimer(false);
    setTimerRunning(false);
    setTimeLeft();
    setIsDisabled(false);
    console.log(values, "valueeeeeees");
    if (verifyOtp === values.otp) {
      try {
        setIsVerify(
          <span className="flex text-gray-500 text-[1.1vw] font-medium items-center gap-x-2">
            <MdVerified className="text-green-500 text-[1vw] font-medium" /> OTP
            Verified
          </span>
        );
        setVerifyStatus(true);
        // toast.success("Verified Successfully")
      } catch {
        console.error("Submission error:OTP Miss Matched");
      }
    } else {
      setIsVerify(
        <span className="flex items-center gap-x-2 text-gray-500 text-[1.1vw] font-medium">
          <MdError className="text-red-600 text-[1.1vw] font-medium" /> OTP
          Missmatched
        </span>
      );

      setVerifyStatus(false);
      // toast.error("OTP Missmatched")
    }
  };

  const handlePrevious = () => {
    setCurrentPage(1);
    setIsVerify();
    setIsDisabled(false);
    setTimer(false);
    setTimerRunning(false);
    setTimeLeft();
    setSelectedUser();
    setVerifyStatus(false);
    setOtp("");
    setMessage();
    dispatch({ type: "RESETNUMBER" });
  };

  const handleUserChange = async (user_id) => {
    setSelectedUser(user_id);
    setTimeLeft(300);
    // Clear previous mobile number while fetching

    try {
      const response = await handleGetUserNumber(dispatch, user_id); // Replace with your API endpoint

      //  setMobileNumber(userNumber)
      console.log(response, "mobileNumber"); // Assuming API returns mobileNumber
    } catch (error) {
      console.error("Error fetching mobile number:", error);
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;
    // Ensure only 6-digit numeric input
    if (/^\d{0,7}$/.test(value)) {
      setOtp(value);
      console.log(otp, "OOOOOO");
    }
  };

  const handleMouseOver = (event) => {
    event.target.removeAttribute("title");
  };
  const GetStatusOpt = () => {
    if (deviceid == "0") {
      return [
        { label: "Normal", payment_type: "Normal" },
        { label: "Instant", payment_type: "Instant" },
      ];
    }
  };

  const handleSubmitCheck = () => {
    handleVerify(verifyValues);

    handleSubmit(valuesForm);

    setSubmitModalIsOpen(true);
  };

  const handleSubmit = async (values) => {
    console.log("Form values:", values);

    try {
      console.log(" values Payid:", values.pay_id);
      console.log(" values Amount:", values.amount);
      if (payId && values.amount) {
        const response = await handleRefundRequestNormal(values);
        console.log(" Response Normal:", response);
      }

      //  console.log(" Response Status:", status);
    } catch (err) {
      console.error("Submission error:", err);
    }
  };

  const handleOTPSubmit = async (values) => {
    if (isClicked) return; 
    setIsClicked(true);
    setTimeLeft(60);
    setIsDisabled(true);
    console.log("Form values:", values);
    try {
      console.log(" values Mobile:", values.userNumber);

      // console.log(" values OTP:", values.otp);
      const otpSent = await handleGetOtp(values);
      console.log(otpSent, "OTP RESPONSE");
    } catch (err) {
      console.error("Submission error:", err);
    }
      setIsClicked(false)
  };
    const handleFareSort = () => {
    let sorted = [...getCancellationDetails];
    if (sortOrderFare === "ascend") {
      sorted.sort((a, b) => b.total_fare - a.total_fare);
      setSortOrderFare("descend");
    } else if (sortOrderFare === "descend") {
      sorted = [...getCancellationDetails]; // Reset to original order
      setSortOrderFare(null);
    } else {
      sorted.sort((a, b) => a.total_fare - b.total_fare);
      setSortOrderFare("ascend");
    }

    console.log(getCancellationDetails, "sort details");
    setSortedData(sorted);
  };

  const handleRefundSort = () => {
    let sorted = [...getCancellationDetails];
    if (sortOrderFare === "ascend") {
      sorted.sort((a, b) => b.refund_amt - a.refund_amt);
      setSortOrderFare("descend");
    } else if (sortOrderFare === "descend") {
      sorted = [...getCancellationDetails]; // Reset to original order
      setSortOrderFare(null);
    } else {
      sorted.sort((a, b) => a.refund_amt - b.refund_amt);
      setSortOrderFare("ascend");
    }

    console.log(getCancellationDetails, "sort details");
    setSortedData(sorted);
  };

  const handleDateSort = () => {
    let sorted = [...getCancellationDetails];
    if (sortOrderDate === "ascend") {
      sorted.sort(
        (a, b) =>
          new Date(b.cancel_date_time) -
          new Date(a.cancel_date_time)
      );
      setSortOrderDate("descend");
    } else if (sortOrderDate === "descend") {
      sorted = [...getCancellationDetails]; // Reset to original order
      setSortOrderDate(null);
    } else {
      sorted.sort(
        (a, b) =>
          new Date(a.cancel_date_time) -
          new Date(b.cancel_date_time)
      );
      setSortOrderDate("ascend");
    }

    console.log(sortedData, "sort details");
    setSortedData(sorted);
  };

  const infos = [
    {
      title: "Ticket Number",
    },
    {
      title: "PNR Number",
    },
    {
      title: "Mobile Number",
    },
    // {
    //   title: "Activated Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
    // {
    //   title: "Expiry Date",
    //   description: "DD MMM (e.g. 01 Jan) - Format",
    // },
  ];
  const handleRowClick = (record) => {
    console.log(record, "record");
    SetUpdateData(record.ticket_no);
    const newExpandedKey = record.key === expandedRowKey ? null : record.key;
    setExpandedRowKey(newExpandedKey);
    console.log(expandedRowKey, "record record");
    setIsRowExpanded(newExpandedKey !== null);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    UnreadNotification(dispatch);
  }, []);

  useEffect(() => {
    // Function to prevent zoom on touch events
    const preventZoom = (e) => {
      if (e.touches.length > 1) {
        e.preventDefault();
      }
    };

    // Function to prevent double tap zoom
    const preventDoubleTapZoom = (e) => {
      e.preventDefault();
    };

    // Add event listeners for touchstart and double tap
    document.addEventListener("touchstart", preventZoom, { passive: false });
    document.addEventListener("dblclick", preventDoubleTapZoom, {
      passive: false,
    });

    // Add event listener for wheel event to prevent zoom on Ctrl + scroll
    const handleWheel = (e) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });

    // Add event listeners for gesture events on Safari
    const preventGestureZoom = (e) => {
      e.preventDefault();
    };
    document.addEventListener("gesturestart", preventGestureZoom);
    document.addEventListener("gesturechange", preventGestureZoom);
    document.addEventListener("gestureend", preventGestureZoom);

    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener("touchstart", preventZoom);
      document.removeEventListener("dblclick", preventDoubleTapZoom);
      window.removeEventListener("wheel", handleWheel);
      document.removeEventListener("gesturestart", preventGestureZoom);
      document.removeEventListener("gesturechange", preventGestureZoom);
      document.removeEventListener("gestureend", preventGestureZoom);
    };
  }, []);
  useEffect(() => {
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content =
      "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.getElementsByTagName("head")[0].appendChild(metaTag);

    // Disable pinch-to-zoom
    const preventZoom = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };

    document.addEventListener("wheel", preventZoom, { passive: false });

    return () => {
      document.removeEventListener("wheel", preventZoom);
    };
  }, []);
  useEffect(() => {
    GetNotificationData(dispatch);
  }, []);

  const reportId = "f8b29529-d035-4c97-ad20-b2d85cfe1151";
  const height = "500px";
  const width = "100%";
  const embedUrl =
    "https://app.powerbi.com/reportEmbed?reportId=f8b29529-d035-4c97-ad20-b2d85cfe1151&groupId=59e770fb-a36e-4bb8-be19-4d0c182c99dd&w=2&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly9XQUJJLUlORElBLUNFTlRSQUwtQS1QUklNQVJZLXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0IiwiZW1iZWRGZWF0dXJlcyI6eyJ1c2FnZU1ldHJpY3NWTmV4dCI6dHJ1ZX19";
  const accessToken =
    "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6Ikg5bmo1QU9Tc3dNcGhnMVNGeDdqYVYtbEI5dyIsImtpZCI6Ikg5bmo1QU9Tc3dNcGhnMVNGeDdqYVYtbEI5dyJ9.eyJhdWQiOiJodHRwczovL2FuYWx5c2lzLndpbmRvd3MubmV0L3Bvd2VyYmkvYXBpIiwiaXNzIjoiaHR0cHM6Ly9zdHMud2luZG93cy5uZXQvMDdiYjM5ZWQtOWM5MC00ZjRmLThlYTctZGFlNWFiNTAwNmQ0LyIsImlhdCI6MTcyNjIwNjI1NywibmJmIjoxNzI2MjA2MjU3LCJleHAiOjE3MjYyMTAxNTcsImFpbyI6IkUyZGdZQkIydnRtVW1MWHBuQVAzQzVHbktVd25BQT09IiwiYXBwaWQiOiI1ZGJkODFiZC0yNGMyLTQwYmMtYmVlNi1iZjBlMzQ1Mjk0OTEiLCJhcHBpZGFjciI6IjEiLCJpZHAiOiJodHRwczovL3N0cy53aW5kb3dzLm5ldC8wN2JiMzllZC05YzkwLTRmNGYtOGVhNy1kYWU1YWI1MDA2ZDQvIiwiaWR0eXAiOiJhcHAiLCJvaWQiOiI1ZTNiMTE4Ny0yOGFjLTRiOWMtYThkZC03MmE0YmY2NzQ1NDMiLCJyaCI6IjAuQVZZQTdUbTdCNUNjVDAtT3A5cmxxMUFHMUFrQUFBQUFBQUFBd0FBQUFBQUFBQUNmQUFBLiIsInN1YiI6IjVlM2IxMTg3LTI4YWMtNGI5Yy1hOGRkLTcyYTRiZjY3NDU0MyIsInRpZCI6IjA3YmIzOWVkLTljOTAtNGY0Zi04ZWE3LWRhZTVhYjUwMDZkNCIsInV0aSI6Ikw1UzVIX09VTjB5X0pCYlY5TE1nQUEiLCJ2ZXIiOiIxLjAiLCJ4bXNfaWRyZWwiOiI3IDI2In0.Ofc3nHFtY_dc0RpyVUQ90a7jXdkxOvQMMllVaOLiyCzhYqNA5gs2zN-XfLSppEcpbt424f_qO6RNRzdRPjYGl4tQuiWAvJ5Chs_34HzQ_-MKhkgYfYBPCFjNDRY8ZnAc1_DaF-0oeS4xJew3L2ML_bO87bVtv6Epp9-ihSo2eOdECojyV7MWd9CKCxCW0DN4UbfIjMj6ZrR_wgmgk6UBZFT-KJ4sIyo-08Q6iCJ0kPaxavm1CdSsHRfj2jQyVgch7BIFdciyv2dkD3Ed1xAwNtUsfCHr2zrN5GZri9J8zUwp9fe803-1uBFk324l4vbRwOXhSQIYpPe-4wmJU2_BJg";
  //-------------------------------------
  const Search = (e) => {
    handleCancellationDetailsSearch(e, dispatch);
  };
  // const [activePage, setActivePage] = useState(1);
  const itemsPerPage = 10; // Number of items to display per page
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    console.log(activePage, "active page");
    console.log(itemsPerPage, "page items");
    setIsRowExpanded(false);
    // SetUpdateData(null);
    setExpandedRowKey(null);
  };
  // Calculate pagination slice based on activePage
  const indexOfLastItem = activePage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems =
  //   getCancellationDetails?.length > 0 &&
  //   getCancellationDetails?.slice(indexOfFirstItem, indexOfLastItem);
  // const currentItems =
  //   sortedData.length > 0
  //     ? sortedData?.slice(indexOfFirstItem, indexOfLastItem)
  //     : getCancellationDetails?.length>0 && getCancellationDetails?.slice?.(indexOfFirstItem, indexOfLastItem);

  const currentItems =
    Array.isArray(sortedData) && sortedData.length > 0
      ? sortedData.slice(indexOfFirstItem, indexOfLastItem)
      : Array.isArray(getCancellationDetails)
      ? getCancellationDetails.slice(indexOfFirstItem, indexOfLastItem)
      : [];
  console.log(currentItems, "currentItems");
  const { RangePicker } = DatePicker;

  // date picker
  const changeDatePickerPlaceholder = () => {
    const inputDiv = document.querySelector(".ant-picker-input");
    if (inputDiv) {
      const inputElement = inputDiv.querySelector("input");
      if (inputElement) {
        inputElement.placeholder = "Start Date";
      }
    }
  };
  changeDatePickerPlaceholder();

  const changeDatePickerPlaceholder2 = () => {
    const inputDiv = document.querySelector(".ant-picker");
    if (inputDiv) {
      const children = inputDiv.querySelectorAll("div");
      if (children.length > 2) {
        const thirdChild = children[2];
        const inputElement = thirdChild.querySelector("input");
        if (inputElement) {
          inputElement.placeholder = "End Date";
        }
      }
    }
  };
  changeDatePickerPlaceholder2();

  const formatDate = (dateStr) => {
    const dateTime = new Date(dateStr);

    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = dateTime.toLocaleDateString("en-GB", options);

    const hours = dateTime.getHours().toString().padStart(2, "0");
    const minutes = dateTime.getMinutes().toString().padStart(2, "0");
    const hour = hours % 12 || 12;
    const ampm = hour >= 12 ? "PM" : "AM";

    return `${formattedDate} (${hours}:${minutes} ${ampm})`;
  };

  const formatDates = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options);
    return `${formattedDate}`;
  };

  //   const formateRefund=(value)=>{
  //  if(value){
  //   return ((value/100)*item.refund_percent)
  //  }
  //   }

  const columns = [
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          S.No
        </div>
      ),
      width: "4vw",
      render: (row, rowdta, index) => {
        const serialNumber = (activePage - 1) * itemsPerPage + index + 1;
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {serialNumber}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Ticket Number
        </div>
      ),
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="text-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row?.ticket_no?.length > 12 ? (
              <Tooltip
                placement="top"
                title={row?.ticket_no}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                {`${row?.ticket_no?.slice(0, 12)}...`}
              </Tooltip>
            ) : (
              <div>{row.ticket_no}</div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          PNR Number
        </div>
      ),
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="text-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row?.pnr_no ? (
              row?.pnr_no.split("/")[0]?.trim().length >= 10 ? (
                <Tooltip
                  placement="top"
                  title={row?.pnr_no.split("/")[0]?.trim()}
                  className="cursor-pointer"
                  color="white"
                  overlayInnerStyle={{
                    color: "#1F487C",
                  }}
                >
                  {`${row?.pnr_no.split("/")[0]?.trim().slice(0, 10)}...`}
                </Tooltip>
              ) : (
                <div>{row.pnr_no.split("/")[0]?.trim()}</div>
              )
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
    // {
    //   title: (
    //     <div
    //       className="text-[1.2vw] text-center font-bold"
    //       style={{ color: "white" }}
    //     >
    //       Source Name
    //     </div>
    //   ),
    //   width: "7vw",
    //   render: (row, rowdta, index) => {
    //     return (
    //       <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw]">
    //         {row.source_name}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: (
    //     <div
    //       className="text-[1.2vw] text-center font-bold"
    //       style={{ color: "white" }}
    //     >
    //       Destination Name
    //     </div>
    //   ),
    //   width: "7vw",
    //   render: (row, rowdta, index) => {
    //     return (
    //       <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw]">
    //         {row?.destination_name?.length > 9 ? (
    //           <Tooltip
    //             placement="right"
    //             title={row?.destination_name}
    //             className="cursor-pointer"
    //             color="white"
    //             overlayInnerStyle={{
    //               color: "#1F487C",
    //             }}
    //           >
    //             {`${row?.destination_name?.slice(0, 8)}...`}
    //           </Tooltip>
    //         ) : (
    //           <div>{row?.destination_name?.slice(0, 9)}</div>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Operator Name
        </div>
      ),
      width: "10vw",
      render: (row, rowdta, index) => {
        return (
          <div className="text-left ml-[1vw] text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            {row.operator_name?.length > 15 ? (
              <Tooltip
                placement="top"
                title={row.operator_name}
                className="cursor-pointer text-[#1F487C]"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <p>{`${row.operator_name.slice(0, 10)}...`}</p>
              </Tooltip>
            ) : (
              <p>{row.operator_name}</p>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Mobile
        </div>
      ),
      width: "6vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw]">
            {row.mobile}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Email
        </div>
      ),
      width: "13vw",
      render: (row, rowdta, index) => {
        return (
          <div className="text-left ml-[2vw] text-[#1F4B7F] text-[1vw] py-[0.5vw]">
            {row?.email?.length >= 15 ? (
              <Tooltip
                placement="top"
                title={row?.email}
                className="cursor-pointer"
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                {`${row?.email?.slice(0, 15)}...`}
              </Tooltip>
            ) : (
              <div>{row.email}</div>
            )}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold flex justify-evenly items-center"
          style={{ color: "white" }}
        >
          <Tooltip
            placement="top"
            title="Cancelling Date / Time"
            className="cursor-pointer"
            color="white"
            overlayInnerStyle={{
              color: "#1F487C",
            }}
          >
            Cancelling D / T
          </Tooltip>
          <button onClick={handleDateSort}>
            {sortOrderDate === "ascend" ? (
              <Tooltip
                placement="top"
                title="Ascending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            ) : sortOrderDate === "descend" ? (
              <Tooltip
                placement="top"
                title="Descending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedDown />
              </Tooltip>
            ) : sortOrderDate === null ? (
              <Tooltip
                placement="top"
                title="Unsorted"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowUnsorted />
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title="Ascending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            )}
          </button>
        </div>
      ),
      key: "cancel_date_time",
      // sorter: (a, b) =>
      //   new Date(a.cancel_date_time.slice(0, 10)) -
      //   new Date(b.cancel_date_time.slice(0, 10)),
      // sortOrder:
      //   sortedInfo.columnKey === "cancel_date_time" && sortedInfo.order,
      width: "13vw",
      render: (row, rowdta, index) => {
        return (
          <div
            className={`text-center text-[#1F4B7F] text-[1vw] py-[0.5vw] ${
              row.cancel_date_time === "Invalid date" ? "text-center" : ""
            }`}
          >
            {row.cancel_date_time === "Invalid date"
              ? "-"
              : `${formatDate(row.cancel_date_time)}`}
            {console.log(row.cancel_date_time, "cancelling date")}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold"
          style={{ color: "white" }}
        >
          Total Paid
        </div>
      ),
      width: "6vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            ₹ {row.total_fare}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold leading-tight"
          style={{ color: "white" }}
        >
          Abhibus Refund
        </div>
      ),
      width: "7vw",
      render: (row, rowdta, index) => {
        return (
          <div className="flex justify-center text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold">
            ₹ {Math.round(row.abhibus_refund * 100) / 100}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] text-center font-bold flex justify-evenly items-center"
          style={{ color: "white" }}
        >
          <p>Refund</p>
          <button onClick={handleRefundSort}>
            {sortOrderFare === "ascend" ? (
              <Tooltip
                placement="top"
                title="Ascending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            ) : sortOrderFare === "descend" ? (
              <Tooltip
                placement="top"
                title="Descending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedDown />
              </Tooltip>
            ) : sortOrderFare === null ? (
              <Tooltip
                placement="top"
                title="Unsorted"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowUnsorted />
              </Tooltip>
            ) : (
              <Tooltip
                placement="top"
                title="Ascending"
                overlayStyle={{pointerEvents:'none'}}
                color="white"
                overlayInnerStyle={{
                  color: "#1F487C",
                }}
              >
                <TiArrowSortedUp />
              </Tooltip>
            )}
          </button>
        </div>
      ),
      // key: "total_fare",
      // sorter: (a, b) => a.total_fare - b.total_fare,
      // sortOrder: sortedInfo.columnKey === "total_fare" && sortedInfo.order,
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="grid grid-cols-4 text-[#1F4B7F] text-[1vw] py-[0.5vw] font-bold justify-center">
            <p className="col-span-3 ml-[2vw]">
              {row.refund_amt === null
                ? "-"
                : `₹ ${
                    row?.refund_amt % 1 === 0
                      ? row.refund_amt
                          .replace(/(\.\d*?[1-9])0+$/, "$1")
                          .replace(/\.0+$/, "")
                      : row.refund_amt
                  }`}
            </p>
            {/* <button
              onClick={(e) => {
                e.stopPropagation();
                handleRowClick(row);
                setDate2(row.cancel_date_time)
              }}
              className="col-span-1"
            >
              {row.key === expandedRowKey ? (
                <IoIosArrowDropupCircle
                  style={{ height: "1.3vw", width: "1.3vw" }}
                />
              ) : (
                <IoIosArrowDropdownCircle
                  style={{ height: "1.3vw", width: "1.3vw" }}
                />
              )}
            </button> */}
          </div>
        );
      },
    },
    {
      title: (
        <div
          className="text-[1.1vw] flex justify-center font-bold"
          style={{ color: "white" }}
        >
          Payment Status
        </div>
      ),
      width: "9vw",
      render: (row, rowdta, index) => {
        return (
          <div className="grid grid-cols-3 space-x-4 text-[#1F4B7F] text-[1.5vw] ">
            <div className="col-span-2 ml-[1vw] ">
              {row.status_type === "null" ? (
                <p className="flex justify-center ml-[1vw]">-</p>
              ) : row.status_type === "Requested" ? (
                // developperAccess == 1 ? (
                <button
                  onClick={() => {
                    setIsModalOpen(true);
                    setRefund(row.refund_amt);
                    setMobile(row.mobile);
                    setEmail(row.email);
                    setPayId(row.payment_id);
                    setTicketNo(row.ticket_no);
                    setCurrentPage(1);

                    console.log(row.cancel_date_time, "PaymentId");
                  }}
                  className="bg-[#FF9900] flex justify-center rounded-[0.5vw] text-[1vw]  font-bold shadow-md shadow-black text-white w-[5.5vw] py-[0.2vw] text-center"
                >
                  Requested
                </button>
              ) : // ) : (
              //   <button
              //     disabled
              //     className="bg-[#FF9900] cursor-not-allowed flex justify-center rounded-[0.5vw] text-[1vw]  font-bold shadow-md shadow-black text-white w-[5.5vw] py-[0.2vw] text-center"
              //   >
              //     Requested
              //   </button>
              // )
              row.status_type === "Refunded" ? (
                <button
                  disabled
                  className=" cursor-not-allowed bg-green-500  flex justify-center rounded-[0.5vw] text-[1vw]  font-bold shadow-md shadow-black text-white w-[5.5vw] py-[0.2vw] text-center"
                >
                  Refunded
                </button>
              ) : (
                <p className="flex justify-center">-</p>
              )}
            </div>

            <button
              onClick={(e) => {
                e.stopPropagation();

                handleRowClick(row);
                setDate2(row.cancel_date_time);
              }}
              className="col-span-1"
            >
              {row.key === expandedRowKey ? (
                <IoIosArrowDropupCircle
                  style={{ height: "1.3vw", width: "1.3vw" }}
                />
              ) : (
                <IoIosArrowDropdownCircle
                  style={{ height: "1.3vw", width: "1.3vw" }}
                />
              )}
            </button>
          </div>
        );
      },
    },
  ];

  const data =
    currentItems?.length > 0 &&
    currentItems?.map((item, index) => ({
      key: index + 1,
      s_no: 1,
      email: item.login_user_email,
      mobile: item.login_user_mobile,
      ticket_no: item.ticket_no,
      pnr_no: item.pnr_no,
      source_name: item.source_name,
      destination_name: item.destination_name,
      operator_name: item.operator_name,
      total_fare: item.total_fare,
      refund_percent: item.refund_percent,
      refund_amt: item.refund_amt,
      cancel_date_time: item.cancel_date_time,
      status_id: item.status_id,
      status_type: item.status_type,
      total_fare: item.total_fare,
      refund_amt: item.refund_amt,
      payment_id: item.payment_id,
      abhibus_refund: item.abhibus_refund,
      partialcancellation: item.partialcancellation,

      hidden_details: (
        <div className="grid grid-cols-6">
          <div className=" col-span-2 border-r-[0.1vw] border-[#1F487C] flex items-center justify-center">
            <div className="px-[2vw] pt-[0.5vw] text-[#1F487C] w-[35vw]">
              <div className="flex items-center justify-between">
                <p className="font-bold text-[1.25vw]">{item.source_name}</p>
                <img src={bus} alt="bus" className="w-[2.5vw]" />
                <p className="font-bold text-[1.25vw]">
                  {item.destination_name}
                </p>
              </div>
              <div className="bg-[#1F487C] h-[0.1vh] my-[0.5vw]" />
              <div className="flex justify-between">
                <div>
                  <div className="flex items-center gap-[0.25vw]">
                    <MdLocationOn />
                    <p className="font-bold text-[1vw]">
                      {item.pickup_point_name?.length >= 15 ? (
                        <Tooltip
                          placement="right"
                          title={item.pickup_point_name}
                          className="cursor-pointer text-[#1F487C]"
                          color="white"
                          overlayInnerStyle={{
                            color: "#1F487C",
                          }}
                        >
                          <p>{`${item.pickup_point_name.slice(0, 15)}...`}</p>
                        </Tooltip>
                      ) : (
                        <p>{item.pickup_point_name}</p>
                      )}
                    </p>
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <MdDateRange />
                    <p>
                      {item.depature_date === null
                        ? "-"
                        : `${formatDates(item.depature_date.slice(0, 10))}`}
                    </p>
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <MdOutlineAccessTime />
                    <p>{item.depature_time}</p>
                  </div>
                  {/* <div className="flex justify-between"><p>GST</p><p>{item.source_id}</p></div> */}
                  {/* <div className="flex justify-between"><p>GST</p><p>{item.pickup_point_id}</p></div> */}
                </div>

                <div className="flex flex-col items-end">
                  <div className="flex items-center gap-[0.25vw]">
                    <p className="font-bold text-[1vw] text-right">
                      {item.droping_point_name ? (
                        item.droping_point_name.length >= 15 ? (
                          <Tooltip
                            placement="left"
                            title={item.droping_point_name}
                            className="cursor-pointer text-[#1F487C]"
                            color="white"
                            overlayInnerStyle={{
                              color: "#1F487C",
                            }}
                          >
                            <p>{`${item.droping_point_name.slice(
                              0,
                              15
                            )}...`}</p>
                          </Tooltip>
                        ) : (
                          <p>{item.droping_point_name}</p>
                        )
                      ) : (
                        "-"
                      )}
                    </p>
                    <MdLocationOn />
                  </div>

                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <p>
                      {item.arrival_date === null
                        ? "-"
                        : `${formatDates(item.arrival_date.slice(0, 10))}`}
                    </p>
                    <MdDateRange />
                  </div>
                  <div className="flex items-center gap-[0.25vw] text-[1vw]">
                    <p>{item.arraival_time}</p>
                    <MdOutlineAccessTime />
                  </div>
                  {/* <div className="flex"><p>GST</p><p>{item.destination_id}</p></div> */}
                  {/* <div className="flex"><p>GST</p><p>{item.droping_point_id}</p></div> */}
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-2 border-r-[0.1vw] border-[#1F487C] flex items-center justify-center w-[35vw]">
            <div className="bg-[#1F487C] rounded-lg w-[30vw]">
              <div className="grid grid-cols-4 border-b-[0.1vw] border-white py-[0.75vw] ">
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white">
                  Seat No
                </span>
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white px-[0.5vw]">
                  Passengers
                </span>
                <span className="text-white font-semibold text-[1vw] w-full border-r-[0.1vw] text-center border-white">
                  Age
                </span>
                <span className="text-white font-semibold text-[1vw] w-full text-center">
                  Gender
                </span>
              </div>
              <div className="grid grid-cols-4 gap-x-[1.5vw] justify-items-center py-[0.25vw] px-[0.6vw]">
                <span className="text-white font-normal text-[1vw]">
                  {item.passenger_details?.map((pass) => (
                    <p>{pass.seat}</p>
                  ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item?.passenger_details === null
                    ? "-"
                    : item.passenger_details?.map((pass) => (
                        <p>
                          {pass.name.length >= 15 ? (
                            <Tooltip
                              placement="top"
                              title={capitalizeFirstLetter(pass.name)}
                              className="cursor-pointer text-white"
                              color="white"
                              overlayInnerStyle={{
                                color: "#1F487C",
                              }}
                            >
                              <p>{`${capitalizeFirstLetter(pass.name).slice(
                                0,
                                10
                              )}...`}</p>
                            </Tooltip>
                          ) : (
                            capitalizeFirstLetter(pass.name)
                          )}
                        </p>
                      ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item?.passenger_details?.map((pass) => (
                    <p>{pass.age}</p>
                  ))}
                </span>
                <span className="text-white font-normal text-[1vw]">
                  {item?.passenger_details?.map((pass) => (
                    <p>{pass.gender}</p>
                  ))}
                </span>
              </div>
            </div>
          </div>
          {date3 >= date1 ? (
            <div className="col-span-2 flex items-center justify-center py-[0.5vw] text-[0.9vw]">
              <div className="border-2 border-dotted border-zinc-800 rounded-[1vw] px-[0.7vw] py-[0.5vw] w-[20vw] ml-[4vw] ">
                <div className="flex justify-between text-[#1F487C]">
                  <p className="font-bold">Partial Cancellation:</p>
                  <p className="font-bold text-[0.9vw]">
                    {item.partialcancellation === null
                      ? "-"
                      : `${item.partialcancellation}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                <div className="flex justify-between text-[#1F487C]">
                  <p className="font-bold">Base Fare:</p>
                  <p className="font-bold">
                    {item.base_fare === null
                      ? "-"
                      : `₹ ${Number(item.base_fare)}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                <div className="flex justify-between text-[#1F487C] ">
                  <p className="font-bold">Cancellation Percentage:</p>
                  <p className="font-bold">
                    {item.refund_percent === null
                      ? "-"
                      : `${100 - item.refund_percent}%`}
                  </p>
                  {/* <p>- ₹ {item?.tbs_deal_amount.endsWith('0') ? item.tbs_deal_amount.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.tbs_deal_amount}</p> */}
                </div>
                <div className="flex justify-between text-red-700">
                  <p className="font-bold">Cancellation fee:</p>
                  <p className="font-bold">
                    {item.refund_amt === null
                      ? "-"
                      : `(-) ₹ ${
                          (item.base_fare / 100) * (100 - item.refund_percent)
                        }`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                {/* `₹ ${Number(item.refund_amt).toFixed(2)}` */}
                <div className="flex justify-between text-red-700">
                  <p className="font-bold">TBS Deal:</p>
                  <p className="font-bold">
                    {item.tbs_deal === null
                      ? "-"
                      : ` (-) ₹ ${Number(item.tbs_deal)}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                {item.tbs_discount > 0 ? (
                  <div className="flex justify-between text-red-700">
                    <p className="font-bold">TBS Discount:</p>
                    <p className="font-bold">
                      {/* {item?.passenger_details?.map((pass) => (
                    <p>(-) ₹ {pass.tbs_discount}</p>
                  ))} */}
                      (-) ₹{" "}
                      {
                        item.bal_tbs_discount === 0||null?"":item.tbs_discount-item.bal_tbs_discount
                      }
                      {/* {item?.passenger_details?.reduce(
                        (acc, pass) =>
                          acc + pass.tbs_discount ? pass.tbs_discount : 0,
                        0
                      )} */}
                      {/* (-) ₹ {item?.tbs_discount - item?.bal_tbs_discount} */}
                    </p>
                  </div>
                ) : (
                  " "
                )}
                <div className="flex justify-between text-red-700">
                  <p className="font-bold">Platform Fee:</p>
                  <p className="font-bold">
                    {`(-) ₹ ${item.passenger_details.length * 15}`}
                  </p>

                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>

                <div className="flex justify-between border-t-[0.1vw] border-zinc-800 mt-[0.3vw]">
                  <p className="font-bold">Total Refund:</p>
                  <p className="font-bold">
                    {item.total_fare && item.refund_amt === null
                      ? "-"
                      : `₹ ${
                          ((item.base_fare||0) / 100) * (item.refund_percent||0) -
                          Number(item.tbs_deal || 0) -
                          item.passenger_details.length * 15 -
                          Number(item.tbs_discount).toFixed(2)
                        }`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                {/* <div className="flex justify-between">
            <p>Status</p>
            <p>{item.payment_status}</p>
          </div> */}
              </div>
            </div>
          ) : (
            <div className="col-span-2 flex items-center justify-center py-[0.5vw] text-[0.9vw]">
              <div className="border-2 border-dotted border-zinc-800 rounded-[1vw] px-[1vw] py-[0.5vw] w-[15vw] ml-[5vw]">
                <div className="flex justify-between text-[#1F487C]">
                  <p className="font-bold">Partial Cancellation</p>
                  <p className="font-bold">
                    {item.partialcancellation === null
                      ? "-"
                      : ` ${item.partialcancellation}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                <div className="flex justify-between text-[#1F487C]">
                  <p className="font-bold">Total Fare</p>
                  <p className="font-bold">
                    {item.total_fare === null
                      ? "-"
                      : `₹ ${Number(item.total_fare).toFixed(2)}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                <div className="flex justify-between text-[#1F487C] ">
                  <p className="font-bold">Refund %</p>
                  <p className="font-bold">
                    {item.refund_percent === null
                      ? "-"
                      : `${item.refund_percent}%`}
                  </p>
                  {/* <p>- ₹ {item?.tbs_deal_amount.endsWith('0') ? item.tbs_deal_amount.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '') : item.tbs_deal_amount}</p> */}
                </div>
                <div className="flex justify-between border-t-[0.1vw] border-zinc-800 ">
                  <p className="font-bold">Refund Amount</p>
                  <p className="font-bold">
                    {item.total_fare && item.refund_amt === null
                      ? "-"
                      : `₹ ${Number(item.refund_amt).toFixed(2)}`}
                  </p>
                  {/* <p className="font-bold">₹ {item.total_fare.replace(/(\.\d*?[1-9])0+$/, '$1').replace(/\.0+$/, '')}</p> */}
                </div>
                {/* <div className="flex justify-between">
            <p>Status</p>
            <p>{item.payment_status}</p>
          </div> */}
              </div>
            </div>
          )}
        </div>
      ),
    }));

  // useEffect(() => {
  //   setSpinning(true);
  //   GetCancellationDetails(dispatch, setSpinning);
  // }, []);

  useEffect(() => {
    setSpinning(true);
    if (deviceid === 0) {
      GetCancellationDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 1) {
      console.log("BookingTable deviceId:", deviceid);
      GetCancellationDetails(dispatch, setSpinning, deviceid);
    } else if (deviceid === 2) {
      console.log("BookingTable deviceId:", deviceid);
      GetCancellationDetails(dispatch, setSpinning, deviceid);
    }
    dispatch({ type: "RESETNUMBER" });
  }, [deviceid]);

  const fetchGetCancellationDetails = async () => {
    try {
      const data = await GetCancellationDetailsById(
        updatedata,
        SetUpdateData,
        operatorData
      );
      setOperatorData(data);
      console.log(data, "Data operator");
    } catch (error) {
      console.error("Error fetching additional user data", error);
    }
  };
  useEffect(() => {
    if (updatedata != null) {
      fetchGetCancellationDetails();
    }
  }, [updatedata]);

  const [dateClear, setDateClear] = useState();
  const datefilter = async (values) => {
    try {
      setDateClear(values);
      console.log(values, "date values");
      await GetCancellationDetailsByDate(
        dispatch,
        moment(values[0].$d).format("YYYY-MM-DD"),
        moment(values[1].$d).format("YYYY-MM-DD")
      );
      setActivePage(1);
    } catch (err) {
      console.log(err, "error");
      GetCancellationDetails(dispatch, setSpinning);
    }
  };
  const handleKeyDown = (e) => {
    // Allow control keys like Backspace, Delete, ArrowLeft, ArrowRight, Tab
    const isControlKey = [
      "Backspace",
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "Delete",
    ].includes(e.key);

    if (isControlKey) {
      return; // If it's a control key, do nothing and allow it to execute
    }

    // Allow only alphabets (A-Z, a-z), numbers (0-9), and space
    if (!/^[A-Za-z0-9\s]$/.test(e.key)) {
      e.preventDefault(); // Prevent the key if it's not an alphabet, number, or space
    }
  };

  return (
    <div>
      {/* <div
      className={`h-screen w-screen pl-[2.5vw] pr-[2.5vw]`}
      style={{
        backgroundImage: `url(${Backdrop})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <h1 className="text-[3vw]">Dashboard</h1>
      <div className="h-[85vh] w-[100%] rounded-[2vw] relative">
      <div className=" absolute w-[87.8vw] h-[85vw] top-[0.1vw] pr-[2vw]">
      <h1>hello</h1>
      <PowerBi />
      <PowerBIReport embedUrl={embedUrl} accessToken={accessToken} />

      <NewPowerbi embedUrl={embedUrl} accessToken={accessToken} />
      <PowerBIReport
              embedUrl={embedUrl}
              accessToken={accessToken}
              reportId={reportId}
              height={height}
              width={width}
            />
      </div>
      <div className="bg-[#99a1ac] h-[70vh] w-[15%] absolute left-[-6vw] top-[3.5vw] rounded-[2vw]"></div>
      </div>
      <div className="flex justify-between items-center ">
          <h1 className="text-[#1F4B7F] pt-[0.5vw] text-[1.5vw] font-bold">
            CANCELLATION DETAILS
          </h1>
          <div className=' w-[4vw] h-[4vw] bg-teal-500 rounded-full order-last'></div>
        </div>
        <div className="flex justify-between">
          <div className="relative flex items-center pb-[0.5vw]">
            <LiaSearchSolid
              className="absolute left-[0.5vw] inline-block  pb-[.1vw]"
              size={"1.1vw"}
              color="#9CA3AF"
            />
            <input
              type="text"
              className="bg-white outline-none pl-[2vw] w-[17vw] text-[#1f487c] h-[5vh] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.25vw] border-b-[0.25vw]"
              placeholder="Search..."
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                Search(e);
              }}
            />
            <span className="inline-block cursor-pointer text-[#1F4B7F] text-[1vw] align-text-bottom absolute right-[1vw]">
              {" "}
              <Popover
                color="white"
                title={
                  <div className=" text-[#1F4B7F] p-[1vw] max-h-[20vw] overflow-auto ">
                    <span className="font-bold">SEARCH BY...</span>
                    {infos.map((info, index) => (
                      <div key={index} className="flex flex-col">
                        <ul
                          className="pl-[1vw]"
                          style={{ listStyleType: "disc" }}
                        >
                          <li className="text-[0.8vw] ">
                            <p className="">{info.title}</p>
                          </li>
                        </ul>
                        <span className="text-[.7vw] pl-[1vw] text-[#9CA3AF]">
                          {info.description}
                        </span>
                      </div>
                    ))}
                  </div>
                }
                placement="bottom"
              >
                <BsExclamationCircle size={"1vw"} color="#9CA3AF" />
              </Popover>
            </span>
          </div>
          <div className="order-last">
            <div className="reqman">
              <ConfigProvider
                theme={{
                  token: {
                    fontSize: ".9vw",
                    lineHeight: 0,
                    colorPrimary: "#1F487C",
                  },
                  components: {
                    DatePicker: {
                      activeBorderColor: "#1F487C",
                      hoverBorderColor: "#1F487C",
                      activeShadow: "#1F487C",
                      cellWidth: 25,
                      cellHeight: 20,
                    },
                  },
                }}
              >
                <RangePicker
                  allowClear={true}
                  autoFocus={false}
                  onChange={datefilter}
                  value={dateClear}
                  className="ads-date1 border-r-[0.75vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C]
                        text-[#1F487C] text-[0.8vw] h-[5vh] w-[100%] rounded-[0.5vw] outline-none px-[1vw] placeholder-[#1F487C]"
                className="custom-range-picker bg-white outline-none pl-[1.5vw] w-[17vw] h-[2.5vw] text-[0.9vw] border-[#1F4B7F] border-l-[0.1vw] px-[1vw] border-t-[0.1vw] rounded-[0.75vw] border-r-[0.2vw] border-b-[0.2vw]"
                disabledDate={(current) => current < dayjs().startOf("day")}
                />
              </ConfigProvider>
            </div>
          </div>
        </div> */}
      <div
        className={`h-[72.3vh] custom-table-container ${
          isRowExpanded ? "mb-[vh]" : ""
        } overflow-y-auto`}
      >
        {spinning ? (
          <div className="absolute top-[50vh] left-[50vw] flex justify-center items-center  z-10">
            <Spin size="large" />
          </div>
        ) : (
          <Table
            className="custom-table"
            columns={columns}
            dataSource={data}
            // onChange={handleChange}
            tableLayout="fixed"
            pagination={false}
            locale={{ emptyText: "No Data Available" }}
            expandable={{
              expandedRowRender: (record) => (
                <p style={{ margin: 0 }}>{record?.hidden_details}</p>
              ),
            }}
            // expandedRowRender={(record) => (
            //   <p style={{ margin: 0 }}>{record?.hidden_details}</p>
            // )}
            expandRowByClick={true}
            // onRow={(record) => ({
            //   onClick: () => handleRowClick(record),
            // })}
            rowClassName={(row) =>
              row?.key === expandedRowKey ? "expanded-row" : ""
            }
            expandIcon={() => null}
            expandIconColumnIndex={-1}
            expandedRowKeys={expandedRowKey ? [expandedRowKey] : []}
          />
        )}
      </div>
      <div className={`${isRowExpanded ? "mb-[10vh]" : ""}`}>
        {getCancellationDetails?.length > 10 && (
          <div className=" mt-[1vw]  flex justify-between items-center ">
            <div className="text-[#1f4b7f] flex text-[1.1vw] gap-[0.5vw] ">
              <span>Showing</span>
              <span className="font-bold">
                {currentItems && currentItems?.length > 0 ? (
                  <div>
                    {indexOfFirstItem + 1} -{" "}
                    {indexOfFirstItem + currentItems?.length}
                  </div>
                ) : (
                  "0"
                )}
              </span>
              <span>from</span>
              <span className="font-bold">
                {" "}
                {getCancellationDetails?.length > 0
                  ? getCancellationDetails?.length
                  : 0}
              </span>
              <span>data</span>
            </div>
            <div>
              <ReactPaginate
                activePage={activePage}
                itemsCountPerPage={itemsPerPage}
                totalItemsCount={getCancellationDetails?.length}
                pageRangeDisplayed={3}
                onChange={handlePageChange}
                itemClass="page-item"
                linkClass="page-link"
                activeClass="active"
                prevPageText={
                  <FontAwesomeIcon icon={faChevronLeft} size="1vw" />
                }
                nextPageText={
                  <FontAwesomeIcon icon={faChevronRight} size="1vw" />
                }
                firstPageText={
                  <FontAwesomeIcon icon={faAngleDoubleLeft} size="1vw" />
                }
                lastPageText={
                  <FontAwesomeIcon icon={faAngleDoubleRight} size="1vw" />
                }
              />
            </div>
          </div>
        )}

        <div>
          <ModalPopup
            show={isModalOpen}
            onClose={closeModal}
            width="45vw"
            height="23vw"
            closeicon={false}
          >
            {currentpage === 1 && (
              <div>
                <div className="grid grid-cols-2 ">
                  <div className=" col-span-1 grid grid-rows-2">
                    <p className="row-span-1 text-[1.3vw] text-[#1F4B7F]  font-bold ml-[1vw]">
                    PAYMENT REFUND
                  </p>
                  <p className=" row-span-1 text-[1.1vw] text-[#909193]  font-medium ml-[1vw]">
                    ( Passenger Details )
                  </p>
                  </div>
                  <div className="col-span-1 flex justify-between gap-x-4 ml-[2.3vw] mr-[1vw]">
                    <button
                      type="button"
                      className="flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw] h-[2.5vw] border-[#1F4B7F]  bg-white px-[2vw]  py-[0.1vw] rounded-[0.7vw] items-center justify-center"
                      style={{ transition: "all 0.3s" }}
                      onClick={closeModal}
                    >
                      Cancel
                    </button>

                    <button
                      type="button"
                      className="flex text-white text-[1vw] border-[0.1vw] w-[8vw] h-[2.5vw] border-[#1F4B7F] bg-[#1F4B7F] px-[2vw]  py-[0.1vw] rounded-[0.7vw] items-center justify-center"
                      style={{ transition: "all 0.3s" }}
                      onClick={() => {
                        if (currentpage === 1) {
                          setCurrentPage(2);
                        }
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
                <Formik
                  initialValues={{
                    mobile: mobile || "",
                    email: email || "",
                    amount: refund || "",
                    payment_type: "Normal",
                    message: "Bus Booking",
                    pay_id: payId,
                    ticket_no: ticketNo,
                  }}
                  onSubmit={(values) => handleSubmit(values)}
                >
                  {({ values, handleSubmit, setFieldValue }) => (
                    setValues(values),
                    console.log(values, "value"),
                    (
                      <Form>
                        <div className="grid  mt-[2.6vw] gap-y-6 ">
                          <div className="col-span-1 grid grid-cols-2 ">
                            <div className=" col-span-1 relative justify-center  ml-[1vw] mr-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Mobile:
                              </label>
                              <div>
                                <Field
                                  as="input"
                                  type="text"
                                  name="mobile"
                                  id="mobile"
                                  disabled
                                  className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
                                  value={mobile}
                                />
                              </div>
                            </div>
                            <div className="col-span-1 relative justify-center   mr-[1vw] ml-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Email:
                              </label>
                              <div>
                                <Field
                                  as="input"
                                  type="text"
                                  name="email"
                                  id="email"
                                  disabled
                                  className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
                                  value={email}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 mt-[1vw]">
                            <div className=" col-span-1 flex-col flex relative ml-[1vw] mr-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Refund Amount:
                              </label>
                              <div>
                                <Field
                                  as="input"
                                  type="text"
                                  name="amount"
                                  id="amount"
                                  disabled
                                  className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
                                  value={refund}
                                />
                              </div>
                            </div>
                            <div className="col-span-1 relative  justify-center  mr-[1vw] ml-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Payment Type:
                                {/* <span className="text-[1vw] text-red-600 pl-[0.25vw]">*</span> */}
                              </label>

                              <Field
                                as="input"
                                type="text"
                                name="paymentType"
                                id="paymentType"
                                disabled
                                className="cursor-not-allowed border-r-[0.25vw] w-full mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.5vw] placeholder:font-sans"
                                value={values.payment_type}
                              />
                            </div>
                          </div>
                          {/* <div className=" grid grid-rows justify-start  mt-[1vw] ml-[1.2vw]">
          <p className="text-[0.9vw]  font-bold text-gray-600 ">Note :<span className="text-[0.8vw]  font-medium text-gray-500 ml-[0.5vw]">The amount will be credited back to your account in 5 to 7 days.</span></p>
          
          
          
        </div> */}

                          <div className="col-span-1 grid grid-cols-1 ml-[1vw] mr-[1vw] mt-[0.6vw]">
                            {/* <label className="text-[#1F4B7F] text-[1vw]  font-bold relative flex items-center">
                          Message:
        </label>
            <Field
            as="textarea"
            name="message"
            id="message" 
            style={{ resize: "none" }}
            placeholder="Please enter your Meassage"
            value={values.message}
            className="border-r-[0.25vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw]  border-[#1F487C] text-[#1F487C] text-[1vw]  h-[4.5vw] w-full rounded-[0.5vw] outline-none px-[0.6vw] pt-[0.5vw] placeholder:text-[1vw] placeholder:font-sans"
            />
<ErrorMessage
            name="message"
            component="div"
            className="text-red-500 text-[0.8vw] bottom-[-1.2vw]"
          /> */}
                          </div>
                        </div>
                      </Form>
                    )
                  )}
                </Formik>
              </div>
            )}

            {currentpage === 2 && (
              <div>
                <Formik
                  enableReinitialize={true}
                  initialValues={{
                    otp: otp || "",
                    userNumber: userNumber || "",
                    ticket_no: ticketNo || "",
                    userName: selectedUser || "",
                  }}
                  // validationSchema={validationSchema}
                  onSubmit={(values) => {
                    handleOTPSubmit(values);
                    console.log(values, "valueeeee");
                  }}
                >
                  {({ values, handleOTPSubmit, setFieldValue,isSubmitting }) => (
                    setVerifyValues(values),
                    (
                      <Form>
                        <div className="grid grid-cols-2">
                          <div className=" col-span-1 grid grid-rows-2">
                    <p className="row-span-1 text-[1.3vw] text-[#1F4B7F]  font-bold ml-[1vw]">
                    PAYMENT REFUND
                  </p>
                  <p className=" row-span-1 text-[1.1vw] text-[#909193]  font-medium ml-[1vw]">
                    ( Approver Details )
                  </p>
                  </div>
                          <div className="col-span-1 flex justify-between gap-x-6 mr-[1vw] ml-[2.3vw]">
                            <button
                              type="button"
                              className="flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw] border-[#1F4B7F] bg-white px-[2vw] h-[2.5vw] gap-[0.5vw] py-[0.1vw] rounded-[0.7vw] items-center justify-center"
                              //   onClick={() => setBgImage(true)}
                              onClick={handlePrevious}
                            >
                              Back
                            </button>
                            <button
                              type="button"
                              className={`cursor-not-allowed flex text-[#1F4B7F] text-[1vw] border-[0.1vw] w-[8vw]  px-[2.5vw] gap-[0.5vw] h-[2.5vw] py-[0.1vw] rounded-[0.7vw] items-center justify-center"
                     ${
                       values.otp && selectedUser
                         ? "cursor-pointer border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] shadow-[#1F487C]"
                         : "cursor-not-allowed border-gray-500 border-[0.1vw]  text-white bg-gray-600 shadow-gray-500 "
                     }
                      `}
                              style={{ transition: "all 0.3s" }}
                              onClick={() => {
                                handleSubmitCheck()
                                setOtpSendState(false)
                              }}
                              disabled={!(values.otp && selectedUser)}
                            >
                              Submit
                            </button>
                          </div>
                          {/* ${values.otp ? 'cursor-pointer border-[#1F487C] border-[0.1vw]  text-white bg-[#1F487C] shadow-[#1F487C]' : 'cursor-not-allowed border-gray-500 border-[0.1vw]  text-white bg-gray-600 shadow-gray-500 '} */}
                        </div>
                        <div className="grid mt-[2.6vw] gap-y-5">
                          <div className="col-span-1 grid grid-cols-2 ">
                            <div className=" col-span-1 relative justify-center  ml-[1vw] mr-[2vw]">
                              <label
                                htmlFor="module_permissions"
                                className="text-[#1F4B7F] text-[1.1vw] font-semibold flex items-center"
                              >
                                User:
                              </label>
                              <div>
                                <ConfigProvider
                                  theme={{
                                    components: {
                                      Select: {
                                        optionActiveBg: "#aebed1",
                                        optionSelectedColor: "#FFF",
                                        optionSelectedBg: "#e5e5e5",
                                        optionHeight: "2",
                                      },
                                    },
                                  }}
                                >
                                  <Select
                                    showSearch
                                    className="custom-select bg-white outline-none w-full mt-[0.2vw] h-[3vw] text-[1vw] border-[#1F4B7F] border-l-[0.1vw] border-t-[0.1vw] rounded-[0.5vw] border-r-[0.25vw] border-b-[0.25vw] "
                                    onMouseOver={handleMouseOver}
                                    onChange={handleUserChange}
                                    value={selectedUser}
                                    suffixIcon={
                                      <span
                                        style={{
                                          fontSize: "1vw",
                                          color: "#1f487c",
                                        }}
                                      >
                                        <IoMdArrowDropdown size="2vw" />
                                      </span>
                                    }
                                    placeholder={
                                      <span
                                        style={{
                                          fontSize: "1vw",
                                          color: "#9E9E9E",
                                        }}
                                      >
                                        Select User
                                      </span>
                                    }
                                  >
                                    {userDetail.map((user) => (
                                      <Option
                                        key={user.user_id}
                                        value={user.user_id}
                                      >
                                        {user.user_name}
                                      </Option>
                                    ))}
                                  </Select>
                                </ConfigProvider>
                              </div>
                            </div>
                            <div className="col-span-1 relative justify-center   mr-[1vw] ml-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Mobile:
                              </label>
                              <div>
                                <Field
                                  as="input"
                                  type="text"
                                  name="mobileNumber"
                                  id="mobileNumber"
                                  placeholder="Selected Mobile Number"
                                  className=" border-r-[0.25vw] w-full mt-[0.3vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[1vw]  rounded-[0.5vw] outline-none px-[1.2vw] py-[1.3vw] placeholder:font-sans"
                                  value={userNumber}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="grid grid-cols-2 mt-[1vw]">
                            <div className=" col-span-1 flex-col flex relative ml-[1vw] mr-[2vw]">
                              <label className="text-[#1F4B7F] text-[1vw]  font-bold flex items-center">
                                Enter OTP:
                              </label>
                              <div className="relative w-full">
                                <Field
                                  type="text"
                                  name="otp"
                                  id="otp"
                                  value={values.otp}
                                  placeholder="Enter 6-Digit OTP"
                                  onChange={handleChange}
                                  disabled={!otpSendState}
                                  className="w-full pr-[8vw] border-r-[0.25vw] mt-[0.2vw] border-l-[0.1vw] border-t-[0.1vw] border-b-[0.25vw] placeholder-blue border-[#1F487C] text-[#1F487C] text-[1vw] h-[3vw] rounded-[0.5vw] outline-none px-[1.2vw] py-[1.3vw] placeholder:font-sans"
                                />
                              </div>
                            </div>
                            <div className="col-span-1 flex-col flex relative ">
                              <button
                                  type="submit"
                                  onClick={()=>{
                                    setOtpSendState(true)
                                  }}
                                  className={`mt-[1.7vw] ml-[11.5vw] mr-[1vw] h-[2.9vw] w-[8vw]  text-white font-semibold bg-[#1F487C]  hover:shadow-none shadow-[#1F487C] rounded-lg text-[1vw]
      ${selectedUser ? "cursor-pointer" : "cursor-not-allowed"}
    `}
                                  style={{ transition: "all 0.3s" }}
                                  disabled={!selectedUser}
                                >
                                  {isDisabled||isClicked
                                    ? `${formatTimer(timeLeft)}`
                                    : timeLeft === 0
                                    ? "Resend OTP"
                                    : "Send OTP"}
                                </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    )
                  )}
                </Formik>
              </div>
            )}
          </ModalPopup>
        </div>
        <div>
          <ModalPopup
            show={submitmodalIsOpen}
            onClose={closeSubmitModal}
            height="21vw"
            width="30vw"
            closeicon={false}
          >
            <div className="flex flex-col items-center mt-[0.5vw] gap-[2vw] justify-center">
              <div className="items-center flex-col flex justify-center ">
                <RiRefund2Line color="#1f4b7f" size={"5vw"} />
                <p className=" flex justify-center text-[1.7vw] font-semibold text-[#1f4b7f] mt-[0.7vw] ml-[1vw]">
                  Are You Sure ?
                </p>
                <p className=" flex justify-center text-[1.1vw] text-[#1f4b7f] mt-[0.5vw]">
                  Do you Want to Refund this Amount{" "}
                  <span className="font-semibold text-[1.1vw] text-[#1f4b7f] ml-[0.5vw]">
                    {refund}
                  </span>{" "}
                  ?
                </p>
                <div className=" h-[1vw] flex justify-center  mt-[0.9vw]">
                  {isVerify}
                </div>
              </div>
              <div className="flex  gap-[2vw]  ">
                <button
                  className="border-[#1f4b7f] border-[0.1vw] rounded-[0.5vw] text-[1.1vw] font-semibold text-[#1f4b7f] w-[10vw]  h-[3vw]"
                  onClick={closeSubmitModal}
                >
                  No
                </button>
                <button
                  type="button"
                  className={`cursor-not-allowed bg-[#1f4b7f] text-white font-semibold text-[1.1vw] w-[10vw] h-[3vw] rounded-[0.5vw]
              ${verifyStatus === true ? "cursor-pointer" : "cursor-not-allowed"}
              `}
                  disabled={verifyStatus === false}
                  onClick={() => {
                    handleSubmitClick();
                    handleOTPVerify(verifyValues);
                  }}
                >
                  Yes
                </button>
              </div>
            </div>
          </ModalPopup>
        </div>
      </div>

      {/* </div> */}
    </div>
  );
}
